import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import TopNavigation from "../Components/TopNavigation";
import BottomNavigation from "../Components/BottomNavigation";
import SocialMediaPost from "../Components/SocialMediaPost";
import { FiMapPin } from "react-icons/fi";

const Search = () => {
  const [locations, setLocations] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [restaurants, setRestaurants] = useState([]);
  const [bgImg, setBgImg] = useState(true);
  const [loca, setLoca] = useState("");
  const loaderRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(
          "https://foodie-read.onrender.com/api/location/all-locations",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response.data.locations);
        setLocations(response.data.locations);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setSearchInput(inputValue);
    setShowSuggestions(inputValue !== "");
  };

  const handleSearch = () => {
    console.log("Search Input:", searchInput);
    if (searchInput === "") {
      setBgImg(true);
    } else {
      setLoca(searchInput);
    }

    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        if (searchInput) {
          loaderRef.current.style.display = "block"; // Show the loader
          setBgImg(false);
          const response = await axios.get(
            `https://foodie-read.onrender.com/api/location/restaurants?location=${searchInput}&page=1`,
            config
          );
          setRestaurants(response.data.restaurants);
          setSearchInput("");
          loaderRef.current.style.display = "none"; // Hide the loader
        }
      } catch (error) {
        console.error("Error fetching restaurants:", error);
      }
    };

    fetchData();
  };

  const handleSuggestionClick = (suggestion) => {
    setSearchInput(suggestion);
    setShowSuggestions(false);
  };

  const suggestions = locations.filter((location) =>
    location.toLowerCase().includes(searchInput.toLowerCase())
  );

  const profileImgs = [
    "Cali",
    "George",
    "Milo",
    "Bandit",
    "Sheba",
    "Kitty",
    "Baby",
    "Socks",
    "Jasper",
    "Snuggles",
    "Pumpkin",
    "Boo",
    "Peanut",
    "Zoe",
    "Scooter",
    "Annie",
    "Smokey",
  ];

  return (
    <div className="flex flex-col min-h-screen">
      <TopNavigation />
      <div className="relative mx-auto max-w-screen-sm mt-20">
        <div className="flex ">
          <input
            type="text"
            className="w-48 px-4 py-2 mr-2 text-gray-700 bg-white border border-gray-300 rounded-md focus:outline-none focus:border-red-700 focus:ring-0 text-sm"
            placeholder="Search..."
            value={searchInput}
            onChange={handleInputChange}
          />
          <button
            type="button"
            className="px-4 py-2 text-white bg-red-600 rounded-md hover:bg-red-700 text-sm"
            onClick={handleSearch}
          >
            Search
          </button>
        </div>

        {showSuggestions && (
          <ul className="mt-2 bg-gray-700 text-white border border-gray-300 rounded-md absolute w-full z-10">
            {suggestions.map((location, index) => (
              <li
                key={index}
                className="px-4 py-2 cursor-pointer hover:bg-gray-100 text-xs"
                onClick={() => handleSuggestionClick(location)}
              >
                {location}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className="flex flex-col flex-grow items-center justify-center pt-5 pb-20 mt-4 px-1">
        {!bgImg ? (
          <div>
            <div className="absolute top-0 left-0 flex items-center pt-24 mt-14 ml-4 z-[-1]">
              <FiMapPin className="h-5 w-5 text-red-600 mr-0.5" />
              <span className="text-base mt-0.5 ml-0.5 font-bold text-gray-700 tracking-wide">
                {loca}
              </span>
            </div>

            <div className="space-y-10 mt-12">
              {restaurants &&
                restaurants.map((restaurant) => {
                  // Generate a random index to select a random profile image
                  const randomIndex = Math.floor(
                    Math.random() * profileImgs.length
                  );
                  const randomProfileImg = profileImgs[randomIndex];

                  // Format the user name to have capitalized words
                  const u_name =
                    restaurant && restaurant.userName
                      ? restaurant.userName
                          .toLowerCase()
                          .split(" ")
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")
                      : "";

                  // Render the SocialMediaPost component with the restaurant data
                  return (
                    <SocialMediaPost
                      key={restaurant._id}
                      userName={u_name}
                      splDish={restaurant.splDish}
                      restaurantName={restaurant.restaurantName}
                      img={restaurant.img}
                      cost={restaurant.cost}
                      rating={restaurant.rating}
                      profilePic={`https://api.dicebear.com/6.x/pixel-art/svg?seed=${randomProfileImg}`}
                      postId={restaurant._id} // Replace "postId" with the actual post ID property
                      className="mr-4 mb-4"
                    />
                  );
                })}
            </div>
          </div>
        ) : (
          <img
            src="https://i.ibb.co/HDRhYSB/My-project-1-removebg-preview.png"
            alt="default"
            className="w-xs h-xs sm:w-sm sm:h-sm"
          />
        )}
        <div
          ref={loaderRef}
          className="w-12 h-12 animate-spin rounded-full border-4 border-solid border-red-600 border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
          style={{ display: "none" }}
        ></div>
      </div>
      <BottomNavigation />
    </div>
  );
};

export default Search;
